<template>
	<div class="ReKanban">
		<template v-if="typeof masKanban.anal != 'undefined' && masKanban.anal.length>0">
			<div class="ReKanban mb-3" v-for="kanban in masKanban.anal" :key="kanban.id">
				<!--pre>{{kanban}}</pre-->
				<h3>{{kanban.BP_NAME}}</h3>

				<div class="row">
					<template v-for="(stage, s_index) in kanban.jdata">
						<collapse class="kanban-col" 
							:key="s_index"
							v-if="!$GVO.isEmpty(stage)" activeIndexType="all">
							<collapse-item :title="serviceTitle(stage)">
								<!--pre>{{stage[serviceTitle(stage)]}}</pre-->
								<template v-for="task_id in stage[serviceTitle(stage)]">
									<div class="taskBlock" v-if="!$GVO.isEmpty(getTask(task_id))" :key="task_id">
										<!--pre>{{task_id}}</pre-->
										<!--pre>{{getTask(task_id)}}</pre-->
										<ReCardTask :objTask="getTask(task_id)" class="taskStatus"/>
									</div>
								</template>
							</collapse-item>
						</collapse>
					</template>
					<!--
					<div class="col-md-6 col-lg">    
						<collapse v-if="masTasks.length>0" activeIndexType="all">
							<collapse-item :title="serviceTitle" >
								<div class="taskBlock" v-for="task in masTasks" :key="task.id">
									<ReCardTask v-if="task.overdue >= '0'" :key="task.id" :objTask="task" class="taskStatus"/>
								</div>
							</collapse-item>
						</collapse>            
					</div>
					-->
				</div>

			</div>
		</template>
		<template v-else>
			<h3>Задач не найдено</h3>
		</template>
	</div>
</template>

<script>
import ReCardTask from "src/our_components/ReCardTask.vue";	
import moment from 'moment';
import VueMoment from 'vue-moment';
import { Collapse, CollapseItem } from 'src/components';
import { Select, Option } from 'element-ui';

export default {
	name: 'ReKanban',
	components: {
		ReCardTask,
		Collapse,
		CollapseItem,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	props: {
		counter: String,
		findId: {
			type: String,
			default: '',
		},
		masKanban: {
			type: [Array, Object],
			default(){return [];}
		}
	},
	data () {
		return {
			ver: 1,
			colIsShown: true,
			//masKanban: [],
			masTasks: [],
			selServVal: '',
			selServOpts:[
				{value:'1',label:'uno'},
				{value:'2',label:'duo'},
			],
			objGetParams: {},
		}
	},
	watch: {
		masKanban(val){
			//console.log('masKanban',val);
			this.masTasks = this.$GVO.unlinkObject(val.tasks);
		}
	},
	computed: {
		
	},
	methods: {
		showColTasks() {
			this.colIsShown = !this.colIsShown;
		},
		/*
		getKanban(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
				for (const key in filter) {
					if(filter[key] == 'true' || filter[key] == true) filter[key] = 1;
					if(filter[key] == 'false' || filter[key] == false) filter[key] = 0;
				}
			}
			this.$GVO.ApiCall('GET_SERVICE_ANAL',{obj:'services',flt:{...filter}})
			.then((objApi) => { 
				if(objApi.success === true){ console.log(objApi);
					this.masKanban = objApi.data;
					this.masTasks = this.$GVO.unlinkObject(this.masKanban.tasks);
				}
			}).catch(errorObjApi => console.log(errorObjApi));
		},
		*/
		serviceTitle(stage){
			let masKeys = Object.keys(stage);
			return masKeys[0];
		},
		getTask(task_id){
			if(typeof this.masTasks[task_id] != 'undefined'){
				return this.masTasks[task_id];
			}
			return {};
		},
	},
	created(){
		/*
		this.objGetParams = this.$GVO.GetAllGet();
		if(typeof this.masKanban == 'undefined' || this.masKanban.length == 0){
			this.getKanban();
		}else{
			this.masTasks = this.masKanban.tasks;
			this.masTasks = this.$GVO.unlinkObject(this.masKanban.tasks);
		}
		*/
	}
}
</script>


<style>
.ReKanban {padding: 0px 5px;}
.ReKanban .colHeader {
	width: 100%;
	align-items: center;
	display: flex;
	justify-content: center;
	padding: 10px;
	margin-bottom: 20px;	
	background-color: #01B0E0;
	border-radius: 4px;
	color: #fff;
	font-size: 1rem;
	cursor: pointer;
}
.ReKanban .colHeader .tim-icons {margin-right: 8px;}
/* .ReKanban .row{flex-wrap: nowrap;} */
.kanban-col{
	width: 400px;
	margin: 0 10px;
}
.task.task-shown {display: block;}
.task.task-hidden {display: none;}
.ReKanban >>> .d-flex {width: max-content;}
.ReKanban .card-collapse .card:not(.card-cinc) .collapsed > .card-body{
	padding: 0; 
	margin-top: 15px;
}
.ReKanban .card-collapse .card:not(.card-cinc) .card-header a {    
    color: #01B0E0;
}
.tasks-page > .card{width: fit-content; min-width: 100%;}
/*.ReKanban #headingOne{height:75px;}*/
.bp_select{max-width: 500px;}

.ReKanban .ReSelectCascade .row {flex-wrap: wrap;}

.ReKanban .formRequired span {display: inline-flex; max-width: 200px;}

@media (max-width: 768px){
	.ReKanban .row{flex-wrap: wrap;}

	.ReKanban .kanban-col{
		width: 95%;
		margin: 0 auto;
	}

	.tasks-page > .card{min-width: 0; width: 100%;}
}
</style>
